
import {PageNotFound} from './root';

PageNotFound.$mount('#gpal-app-root');